export const CUSTOM_PLI: string = 'CUSTOM_PLI';
export const ALPHANUMERIC_SPACE_REGEX = /[^a-zA-Z0-9 ]/g;